import { styled } from '@mui/material';

export const StyledBaseTooltipWrapper = styled('div')(
  ({ $overflowWidth, $cursor }) => `
    cursor: ${$cursor};

    ${
      $overflowWidth
        ? `
      display: inline-block;
    `
        : ''
    }
  `,
);

export const StyledTooltipWrapper = styled(StyledBaseTooltipWrapper)(
  ({ $overflow, $overflowWidth, $overflowLineNumber }) => `
    & > :nth-child(1) {
       ${
         $overflowWidth
           ? `
        display: inline-block;
        white-space: pre;
      `
           : ''
       }
      ${
        $overflow && $overflowWidth
          ? `
        max-width: ${$overflowWidth}px;
        overflow: hidden;
        white-space: pre;
        text-overflow: ellipsis;
      `
          : ''
      }
      ${
        $overflowLineNumber
          ? `
        overflow: hidden;
        overflow-wrap: break-word;
        display: -webkit-box;
        -webkit-line-clamp: ${$overflowLineNumber};
        -webkit-box-orient: vertical;
        white-space: pre-wrap;
        text-overflow: ellipsis;
      `
          : ''
      }
    }
  `,
);
